export const yearOptions = [];
const currentYear = new Date().getFullYear();
const startYear = '2025';
const endYear = '1960';

for (let year = startYear; year >= endYear; year--) {
  yearOptions.push(
    {
        label: year.toString(),
        value: year.toString()
    }
  );
}